import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { FieldModel } from "@cv-invision/cv.invision-views.ux";

@Component({
	selector: 'cv-table-array',
	templateUrl: './table-array.component.html',
	styleUrls: ['./table-array.component.scss'],
})
export class TableArrayComponent {

	@Input() field: FieldModel;
	@Input() arrayChilds: any;

	@Output() addFormArray = new EventEmitter<any>();
	@Output() deleteFormArray = new EventEmitter<any>();

	deleteChild(index) {
		this.deleteFormArray.emit({index});
	}

	createChild() {
		this.addFormArray.emit({createFormControls: true});
	}
}
